"use strict";

angular.module("portal.login").controller("ForgotPassword", [
    "$q",
    "$scope",
    "$state",
    "$rootScope",
    "Users",
    "Enterprise",
    "EnterpriseLoginCriteria",
    function (
        $q,
        $scope,
        $state,
        $rootScope,
        Users,
        Enterprise,
        EnterpriseLoginCriteria
    ) {
        $scope.loading = true;
        $scope.resetting = false;
        $scope.hasPublicIdentityProviders = false;
        $scope.disablePasswordLogin = false;
        $scope.displayForm = false;
        $scope.widgetId = null;
        $scope.failedMessages = [];
        $scope.login_criteria = {};
        $scope.parameters = { enterpriseID: $rootScope.enterpriseID };
        $scope.reset_object = {
            enterprise_id: $rootScope.enterpriseID,
            is_public: true
        };

        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
        } else {
            Enterprise.getLess({ enterpriseID: $rootScope.enterpriseID, isPortal: true }).then(
                function (result) {
                    $scope.enterprise = result;
                }
            );
        }

        //recaptcha vars
        $scope.recaptchaMessage = ($scope.enterprise.recaptcha_site_key_v3 == null && $scope.enterprise.recaptcha_enabled) ? "There was an issue loading recaptcha, please try again or contact system administrator." : ""; //message to display

        var promises = [];

        // Get the login criteria
        promises.push(EnterpriseLoginCriteria.get($scope.parameters).then(function (results) {
            if (results != null) {
                $scope.login_criteria = results;
            }
        }));

        //Checking if login via password is disabled
        promises.push(EnterpriseLoginCriteria.getEnterpriseDisablePasswordLogin().then(function (disable) {
            $scope.disablePasswordLogin = disable;
        }));

        //Checking if there are any identity providers set up for public portal
        promises.push(Enterprise.listPublicEnterpriseIdentityProvider().then(function (idpList) {
            $scope.hasPublicIdentityProviders = idpList && idpList.length > 0;
        }));

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });  

        $scope.setDisplayForm = function () {
            $scope.displayForm = true;
        }

        $scope.reset = function () {
            $scope.failedMessages = [];
            $scope.resetting = true;
            Users.forgotPassword($scope.reset_object).then(function (result) {
                if (result != null) {
                    $state.go("portal.menus.login", {
                        messages: result.messages,
                        keepMessages: true
                    });
                }
                $scope.resetting = false;
            });
        };

        $scope.recaptchaSubmit = function () {
            $scope.resetting = true; //if there is a loading type var for display
            if ($scope.enterprise.recaptcha_enabled) {
                if ($scope.enterprise.recaptcha_site_key_v3 != null) {
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha.execute($scope.enterprise.recaptcha_site_key_v3, { action: 'publicForgotPassword' }).then(function (token) { //execute returns a token
                                return Enterprise.getRecaptchaResponse("publicForgotPassword", token) // send action, token, score to pass over to server for validation, returns a response object
                            }).then(function (response) { // take the response and update variables
                                if (response.success == false) {
                                    $scope.recaptchaMessage = 'Recaptcha Error: ' + response.error;
                                    $scope.resetting = false; //if there is a loading type var for display
                                } else {
                                    $scope.recaptchaMessage = "";
                                };
                            }).then(function () {
                                if ($scope.recaptchaMessage == "") {
                                    $scope.reset(); //put function here if passed to continue normal "submit" is recaptcha passed
                                } else {
                                    $scope.$apply(); //update dom so error message displays if recaptcha failed
                                };
                            })
                        } catch (error) {
                            $scope.recaptchaMessage = "There was an issue loading recaptcha, please try again or contact system administrator.";
                            $scope.resetting = false; //if there is a loading type var for display
                        }
                    });
                } else {
                    return;
                }
            } else {
                $scope.reset(); //put function here to continue normal "submit" if recaptcha is turned off
            };
        };


        $scope.cancel = function () {
            $scope.loading = true;
            $state.go("portal.menus.login", {});
        };
    }
]);
